module.exports = __webpack_public_path__ + "assets/retina_APtOnCircleMaxDistDetailed.657cc692bccdba4db9695d00fa3b2b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_APtOnCircleMaxDistDetailed.png
// module id = 608
// module chunks = 0